


















import Vue from 'vue';
import { DreamWebDAO } from '@/web';

export interface DreamDeleteModalInterface extends Vue {
  show(): void;
  hide(): void;
  deleteDream(): void;
}

export default Vue.component('DreamDeleteModal', {
  name: 'DreamDeleteModal',
  props: {
    id: String,
  },
  methods: {
    deleteDream(): void  {
      console.log('Delete dream id ', this.id);
      this.$modal.hide('deleteDreamModal');
      DreamWebDAO.getInstance().deleteDream(this.id);
      this.$router.push('/dreams');
    },
    show(): void {
      this.$modal.show('deleteDreamModal');
    },
    hide(): void {
      this.$modal.hide('deleteDreamModal');
    },
  },
});
